import { Reorder, useDragControls } from 'framer-motion';
import { GripVertical } from 'lucide-react';
import { ComponentProps } from 'react';

import { cn } from '@/utils/styles';

const DragItem = ({ children, className, value, ...rest }: ComponentProps<typeof Reorder.Item>) => {
  const controls = useDragControls();

  return (
    <Reorder.Item value={value} dragControls={controls} {...rest}>
      <div className={cn('flex select-none rounded-md bg-white shadow-soft', className)}>
        <div
          onPointerDown={(e) => controls.start(e)}
          className="grid cursor-grab place-items-center px-1.5 text-grey-400 hover:text-grey-700 active:cursor-grabbing"
        >
          <GripVertical size={16} />
        </div>
        {children}
      </div>
    </Reorder.Item>
  );
};

export { DragItem };
